import React, { useEffect, useState } from "react";
import axios from "axios";

export default function RevenueDetails() {
  const [funds, setFunds] = useState([]);
  const [filteredFunds, setFilteredFunds] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchApprovedFunds();
  }, []);

  const fetchApprovedFunds = async () => {
    try {
      const res = await axios.get("https://api.speedfollowinfo.com/api/admin/approved-funds");
      if (res.data.success) {
        setFunds(res.data.funds || []);
        setFilteredFunds(res.data.funds || []);
      }
    } catch (err) {
      console.error("❌ Fetch Approved Funds Error:", err);
    }
  };

  // ✅ Search & Date Filter Logic
  useEffect(() => {
    let data = [...funds];

    // Search filter
    if (search.trim()) {
      data = data.filter(
        (f) =>
          f.userId?.username?.toLowerCase().includes(search.toLowerCase()) ||
          f.userId?.email?.toLowerCase().includes(search.toLowerCase()) ||
          f.transactionId?.toLowerCase().includes(search.toLowerCase())
      );
    }

    // Date filter
    if (startDate) {
      data = data.filter((f) => new Date(f.createdAt) >= new Date(startDate));
    }
    if (endDate) {
      data = data.filter((f) => new Date(f.createdAt) <= new Date(endDate));
    }

    setFilteredFunds(data);
  }, [search, startDate, endDate, funds]);

  // ✅ Export CSV
  const exportToCSV = () => {
    if (filteredFunds.length === 0) {
      alert("⚠️ No data to export!");
      return;
    }

    const headers = [
      "Username,Email,Txn ID,Method,Amount (৳),Status,Date\n",
    ];
    const rows = filteredFunds.map((f) => {
      const date = new Date(f.createdAt).toLocaleString("en-GB");
      return `${f.userId?.username || "Unknown"},${f.userId?.email || "N/A"},${
        f.transactionId
      },${f.method},${f.amount},${f.status},${date}`;
    });

    const blob = new Blob([headers + rows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Approved_Funds_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
  };

  return (
    <div className="p-6 text-white min-h-screen bg-[#0b0f1a]">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <h2 className="text-2xl font-bold text-[#22c55e]">
          💹 Total Revenue — Approved Funds
        </h2>

        <button
          onClick={exportToCSV}
          className="bg-[#22c55e] hover:bg-[#16a34a] text-black font-semibold px-5 py-2 rounded-lg transition"
        >
          ⬇️ Export CSV
        </button>
      </div>

      {/* 🔍 Filters */}
      <div className="bg-[#111827] p-4 rounded-lg mb-6 flex flex-col md:flex-row gap-4 md:items-center">
        <input
          type="text"
          placeholder="🔍 Search username, email, or Txn ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="bg-[#1b2138] border border-gray-700 rounded-md px-3 py-2 text-white w-full md:w-1/3"
        />

        <div className="flex gap-3 items-center w-full md:w-auto">
          <label className="text-gray-400 text-sm">From:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-[#1b2138] border border-gray-700 rounded-md px-3 py-2 text-white"
          />
          <label className="text-gray-400 text-sm">To:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-[#1b2138] border border-gray-700 rounded-md px-3 py-2 text-white"
          />
        </div>
      </div>

      {/* 🧾 Table */}
      <div className="overflow-x-auto rounded-lg shadow-lg border border-gray-700">
        <table className="w-full text-sm text-left">
          <thead className="bg-[#111827] text-[#22c55e] uppercase">
            <tr>
              <th className="p-3">Username</th>
              <th className="p-3">Email</th>
              <th className="p-3">Txn ID</th>
              <th className="p-3">Method</th>
              <th className="p-3">Amount (৳)</th>
              <th className="p-3">Status</th>
              <th className="p-3">Date</th>
            </tr>
          </thead>

          <tbody>
            {filteredFunds.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center p-4 text-gray-400 italic">
                  No approved funds found
                </td>
              </tr>
            ) : (
              filteredFunds.map((fund) => (
                <tr
                  key={fund._id}
                  className="border-b border-gray-700 hover:bg-[#1f2937] transition"
                >
                  <td className="p-3">{fund.userId?.username || "Unknown"}</td>
                  <td className="p-3">{fund.userId?.email || "N/A"}</td>
                  <td className="p-3 text-[#00eaff] font-semibold">
                    {fund.transactionId}
                  </td>
                  <td className="p-3">{fund.method}</td>
                  <td className="p-3 text-[#22c55e] font-semibold">
                    ৳{fund.amount}
                  </td>
                  <td>
                    <span className="bg-green-500 text-black font-semibold px-3 py-1 rounded-full text-xs">
                      {fund.status}
                    </span>
                  </td>
                  <td className="p-3 text-gray-400">
                    {new Date(fund.createdAt).toLocaleString("en-GB")}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}